import { useProfile } from './UserHooks';
import { ApiScope } from '../types/api-scopes';

export const useScopes = () => {
    const { userProfile, loading } = useProfile();

    // Backwards compatibility: if the backend does not send scopes,
    // assume full access so the existing UI keeps working.
    let scopes: string[] = [];
    const rawScopes = (userProfile as any)?.scopes;
    if (Array.isArray(rawScopes) && rawScopes.length > 0) {
        scopes = rawScopes;
    } else if (!Array.isArray(rawScopes)) {
        scopes = [ApiScope.ALL];
    }

    const hasScope = (...requiredScopes: ApiScope[]): boolean => {
        if (!scopes.length) return false;
        if (scopes.includes(ApiScope.ALL)) return true;
        return requiredScopes.every((scope) => scopes.includes(scope));
    };

    const hasAnyScope = (...requiredScopes: ApiScope[]): boolean => {
        if (!scopes.length) return false;
        if (scopes.includes(ApiScope.ALL)) return true;
        return requiredScopes.some((scope) => scopes.includes(scope));
    };

    return { userProfile, loading, scopes, hasScope, hasAnyScope };
};
